const ERROR_CONTACT_SUPPORT = 'Please try again later or contact support@swipecast.com'
const ERROR_FALLBACK = 'Unknown error occurred.' + ' ' + ERROR_CONTACT_SUPPORT

const ErrorsHelper = {
  ERROR_FALLBACK,
  ERROR_CONTACT_SUPPORT,

  user: {
    /* should match backend version */
    emailTaken: 'Error: A user with that email address already exists',
  },
  stripe: { paymentMethodUnprocessable: 'Unable to save payment method. Please try again later.' },

  normalizeError: (err, defaultMessage = ERROR_FALLBACK) => {
    if (typeof err === 'string') return err
    return err?.responseJSON?.message || err?.message || defaultMessage
  },
}

export default ErrorsHelper
